export const PL_ROUTING = {
  CLIENTS: 'clients',
  CONTACT_SALES: 'contact-sales',
  LANDING_HOME: 'landing-home',
  CALENDAR: 'calendar',
  NO_ACCOUNT: 'no-account',
  PURCHASE: 'purchase',
  REGISTRATION: 'registration',
  USER_MANAGEMENT: 'user-management',
  REPORTS: 'reports',
};
